import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import DisbursementsHeader from '../Auth/components/DisbursementsHeader';
import { Body, DisbursementBody } from './style';
import {
  DisbursementsContext,
  DisbursementsProvider,
} from '../../contexts/DisbursementsContext';
import LinkExpired from './LinkExpired';

function DisbursementWrapper(props) {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    // add disbursements class to root tag
    document.getElementById('root').classList.add('disbursements');
    // Always return a cleanup function; remove only if we added it
    return () => {
      document.getElementById('root').classList.remove('disbursements');
    };
  }, []);

  useEffect(() => {
    if (location.pathname === '/disbursements') {
      navigate('/disbursements/redeem', { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <DisbursementsProvider {...props}>
      <DisbursementsHeader {...props} />
      <DisbursementsBodyWithContext {...props} />
    </DisbursementsProvider>
  );
}

const DisbursementsBodyWithContext = props => {
  const { error } = useContext(DisbursementsContext);
  const errorCodes = {
    link_expired: <LinkExpired {...props} />,
  };
  const renderChildren = () => {
    if (error) {
      return errorCodes[error] || null;
    }
    return props.children;
  };
  return (
    <DisbursementBody>
      <Body>{renderChildren()}</Body>
    </DisbursementBody>
  );
};

DisbursementsBodyWithContext.propTypes = {
  children: PropTypes.node.isRequired,
};
DisbursementWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DisbursementWrapper;
